import React from 'react'
import { Link } from 'react-router-dom'
import Tooltip from 'material-ui/Tooltip'
import Typography from 'material-ui/Typography'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

const DeepLink = ({ link, title, classes }) => {
  return (
    <div className={classes.root}>
       <Typography>
          <Typography
          component={Link}
          to={link}>
          {title}
        </Typography>
      </Typography>
      
      <Typography>
        <Icon>chevron_right</Icon>
      </Typography>
    </div>
  )
}

export default withStyles(styles)(DeepLink)



// WEBPACK FOOTER //
// ./src/components/ui/deepLink/index.js